<div class="monitor-dashboard-page-shell monitor-dashboard-page-section monitor-dashboard-notifications330">
  <div class="mb-4">
    <h2 class="mb-0 font-weight-bold monitor-dashboard-title">
      {{$t('monitorDashboard.notifications330Dashboard')}}
    </h2>
  </div>

  <div class="mb-4">
    <div class="monitor-dashboard-filters-wrapper">
      <div class="monitor-dashboard-filters-grid">

        <div class="monitor-dashboard-filter-item monitor-dashboard-filter-item-date">
          <div class="monitor-dashboard-filter-title">{{$t('monitorDashboard.createdDate')}}</div>
          <vc-date-picker v-model="createdDateRangeInternal" :model-config="createdDateModelConfig"
            :min-date="minDate || todayStr" :max-date="todayStr" is-range color="gray"
            :popover="{ placement: 'bottom-start' }">
            <template v-slot="{ togglePopover }">
              <v-text-field :value="dateRangeText" append-icon="event" dense hide-details solo flat readonly
                class="monitor-dashboard-filter-control monitor-dashboard-date-control"
                @click.native="togglePopover()" />
            </template>
          </vc-date-picker>
        </div>

        <div class="monitor-dashboard-filter-item">
          <div class="monitor-dashboard-filter-title">{{$t('monitorDashboard.customerType')}}</div>
          <v-select v-model="draftFilter.customerType" :items="customerTypes" item-text="name" item-value="id" dense
            hide-details solo attach :menu-props="monitorDashboardSelectMenuProps"
            class="monitor-dashboard-filter-control" />
        </div>

        <div class="monitor-dashboard-filter-item">
          <div class="monitor-dashboard-filter-title">{{$t('monitorDashboard.smsServiceProvider')}}</div>
          <v-select v-model="draftFilter.providerId" :items="providers" item-text="name" item-value="id" dense
            hide-details solo attach :menu-props="monitorDashboardSelectMenuProps"
            class="monitor-dashboard-filter-control monitor-dashboard-filter-control--provider" />
        </div>

        <div class="monitor-dashboard-filter-item">
          <div class="monitor-dashboard-filter-title">{{$t('monitorDashboard.serviceProvider')}}</div>
          <v-select v-model="draftFilter.tenant" :items="operatorTenants" item-text="name" item-value="id" dense
            hide-details solo attach :menu-props="monitorDashboardSelectMenuProps"
            class="monitor-dashboard-filter-control" />
        </div>

        <div class="monitor-dashboard-filter-button-item monitor-dashboard-filter-button-item-shrink">
          <div class="monitor-dashboard-filter-title monitor-dashboard-filter-title-placeholder"></div>
          <button class="btn btn-primary btn-action monitor-dashboard-filter-button" type="button"
            :disabled="isDraftDateRangeInvalid"
            :aria-invalid="isDraftDateRangeInvalid ? 'true' : 'false'"
            @click="applyFilters">
            {{$t('shared.apply')}}
          </button>
        </div>

        <div class="monitor-dashboard-filter-button-item monitor-dashboard-filter-button-item-shrink">
          <div class="monitor-dashboard-filter-title monitor-dashboard-filter-title-placeholder"></div>
          <button class="btn btn-primary btn-action monitor-dashboard-filter-button"
            @click="resetFilters">
            {{$t('shared.reset')}}
          </button>
        </div>

      </div>
    </div>
    <div v-if="isDraftDateRangeInvalid" class="small text-danger mt-2 px-1" role="alert">
      {{ $t('monitorDashboard.invalidDateRange') }}
    </div>
  </div>

  <div class="monitor-dashboard-section-shell">
    <div class="monitor-dashboard-panel-row">
      <div class="w-100 monitor-dashboard-notifications330">
        <notifications330-kpi-cards ref="kpiCards" :filter="chartFilter"></notifications330-kpi-cards>
      </div>

      <div class="monitor-dashboard-panel-item">
        <complaints-statuses-chart ref="complaintsStatusesChart" :filter="chartFilter"></complaints-statuses-chart>
      </div>

      <div class="monitor-dashboard-panel-item">
        <complaint-frequency-per-sender-chart ref="complaintFrequencyPerSenderChart" :filter="chartFilter">
        </complaint-frequency-per-sender-chart>
      </div>

      <div class="monitor-dashboard-panel-item">
        <complaints-timeline-chart ref="complaintsTimelineChart" :filter="chartFilter"></complaints-timeline-chart>
      </div>
    </div>
  </div>
</div>
